import { Injectable } from '@angular/core';
import { ApiService } from 'app/services/api.service';

@Injectable()
export class UserService {

  private _userNameKey = "username";

  public isAdmin: boolean;

  constructor(
    private apiSvc: ApiService
  ) { }

  public isLoggedIn() {
    //console.log("isLoggedIn", this.getToken());
    if (this.apiSvc.getToken()) {
      return true;
    }

    return false;
  }


  public getUserName(): string {
    return localStorage.getItem(this._userNameKey);
  }

  public setUserName(value: string) {
    localStorage.setItem(this._userNameKey, value);
  }

  public getLiveStatus() {
    this.apiSvc.post("api/account/status", null).subscribe((data: Number) => {
      console.log(data);

      this.isAdmin = false;
      if (data >= 98) {
        this.isAdmin = true;
      }
    }, (err) => {
      console.log(err);
    });
  }

}

